import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sidebar, Menu, MenuItem, sidebarClasses } from "react-pro-sidebar";

import HomeIcon from "@mui/icons-material/HomeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useGetLabelsQuery } from "../../features/labels/labelsApiSlice";

import LabelsItem from "./LabelsItem";

function SideBarLayout(props) {
  const [toggle, setToggle] = useState(props.toggle);
  //const labels = useSelector((state) => selectAllLabels(state));
  const { data: labels, isSuccess } = useGetLabelsQuery("labelsList", {
    pollingInterval: 60000,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });
  useEffect(() => {
    setToggle(props.toggle);
  }, [props.toggle]);
  let content;
  if (isSuccess) {
    const { ids } = labels;
    content = (
      <div className="sidebar-menu">
        <Sidebar
          collapsed={toggle}
          rootStyles={{
            [`.${sidebarClasses.container}`]: {
              backgroundColor: props.style.backgroundColor,
              color: props.style.color,
            },
            borderColor: props.style.backgroundColor,
            height: "100vh",
          }}
        >
          <Menu
            className="menu"
            closeOnClick={true}
            menuItemStyles={{
              button: {
                "&:hover": {
                  backgroundColor: "#adaca8",
                },
              },
            }}
          >
            <MenuItem component={<Link to="/" />} icon={<HomeIcon />}>
              Home
            </MenuItem>
            {ids?.map((labelId, i) => (
              <LabelsItem key={i} labelId={labelId} />
            ))}
            <MenuItem
              onClick={() => {
                props.onEditLabelsClick();
              }}
              icon={<EditOutlinedIcon />}
            >
              Edit Label
            </MenuItem>
          </Menu>
        </Sidebar>
      </div>
    );
  }
  return content;
}

export default SideBarLayout;
